// Generic, cross-cutting strings reused across many components.
// Component-specific text belongs in that component's own namespace file instead.
const common = {
  actions: {
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    close: "Close",
    submit: "Submit",
    confirm: "Confirm",
    back: "Back",
    next: "Next",
    previous: "Previous",
    search: "Search",
    filter: "Filter",
    retry: "Retry",
    download: "Download",
    upload: "Upload",
    view: "View",
    select: "Select",
    ok: "OK",
    yes: "Yes",
    no: "No",
    logout: "Logout",
    settings: "Settings",
    create: "Create",
    update: "Update",
    remove: "Remove",
    add: "Add",
    continue: "Continue",
    done: "Done",
    refresh: "Refresh",
    copy: "Copy",
    copied: "Copied",
  },
  languageSwitcher: {
    label: "Language",
  },
  status: {
    loading: "Loading...",
    saving: "Saving...",
    submitting: "Submitting...",
    deleting: "Deleting...",
    error: "Error",
    success: "Success",
    pending: "Pending",
    approved: "Approved",
    rejected: "Rejected",
    completed: "Completed",
    failed: "Failed",
  },
  fields: {
    name: "Name",
    email: "Email",
    date: "Date",
    created: "Created",
    updated: "Updated",
    status: "Status",
    description: "Description",
    type: "Type",
    role: "Role",
    project: "Project",
    required: "Required",
    optional: "Optional",
  },
  misc: {
    all: "All",
    none: "None",
    unknown: "Unknown",
    somethingWentWrong: "Something went wrong",
    noResultsFound: "No results found",
  },
  // The DataRequestStatus enum values used for data/access requests across
  // YourRequestsPage, ProjectRequestsPanel, and AdminRequestsSplitView.
  requestStatus: {
    pending: "Pending",
    awaiting_confirmation: "Awaiting confirmation",
    approved: "Approved — awaiting delivery",
    fulfilled: "Fulfilled",
    rejected: "Rejected",
    redirected: "Redirected",
  },
};

export default common;
